import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import styles from './MileageSaarathi.module.css';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { IoPersonOutline } from "react-icons/io5";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaRegAddressCard } from "react-icons/fa";
import { FaRupeeSign } from "react-icons/fa";
import { BsSpeedometer2 } from "react-icons/bs";
import { FaBook } from "react-icons/fa";
import { FaRegCreditCard } from "react-icons/fa";
import CustomSelectButton from './CustomSelectButton';
import ChartLoader from './Loader_MS_bus';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";


const ServiceSummaryTable = forwardRef((props, ref) => {
    const { filterdata, setExpertInsightLoading } = props;
    const [tableData, setTableData] = useState([])
    const [vinNo, setVinNumber] = useState([])
    const [regNo, setRegNumber] = useState([])
    const [selectedField, setSelectedField] = useState("VIN_NUM")

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [modalData, setModalData] = useState({})

    const [filterData, setFilterData] = useState({
        // startDate: "",
        // endDate: "",
        VIN_NUM: [],
        CITY: [],
        ROUTE: [],
        REG_NUM: []
    })

    useEffect(() => {
        getTableData()
    }, [selectedField, filterdata])


    const getTableData = (vinNo = [], regNo = []) => {
        setExpertInsightLoading(true)
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/service_summary`,
                body: {
                    filterdata: {
                        ...filterdata,
                        VIN_NUM: selectedField === "VIN_NUM" ? vinNo.map(item => item?.value) : [],
                        REG_NUM: selectedField === "REG_NUM" ? regNo.map(item => item?.value) : []
                    }
                }
            },
            (data) => {
                setTableData(data)
                setExpertInsightLoading(false)
            }
        );
    }

    const handleServiceAdherenceClick = (vin_no) => {
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi/service_adherence`,
                body: { filterdata: { ...filterdata, VIN_NUM: [vin_no], REG_NUM: [] } }
            },
            (data) => {
                let resData = data[0]["_source"] || {}
                setModalData(resData)
            }
        );
    };

    const updateFilter = (arr, index) => {
        setVinNumber(arr)
    }

    const updateFilterForREGNo = (arr, index) => {
        setRegNumber(arr)
    }


    const serviceDueStatus = (DisToService) => {

        let dueStatus = "notDue"
        let label = "Not Due"

        if (DisToService >= 1000) {
            dueStatus = "notDue"
            label = "Not Due"
        }
        if (DisToService < 1000) {
            dueStatus = "due"
            label = "Due"
        }
        if (DisToService <= 0) {
            dueStatus = "overDue"
            label = "Over Due"
        }


        const badgeStyle = {
            display: "block",
            margin: "0px auto",
            padding: '2px 6px',
            borderRadius: '4px',
            fontWeight: '600',
            width: '100px',
            fontSize: '12px',
            color: dueStatus == "notDue" ? '#27aa57' : dueStatus == "due" ? "#f76031" : '#c92a31', // dark green / dark red text
            backgroundColor: dueStatus == "notDue" ? '#CEECD9' : dueStatus == "due" ? "#f2d1c7" : '#f4d3d4', // green / red background 
            border: `no border`,
        };

        return <span style={badgeStyle}>{label}</span>;
    }

    const [clearFilters, setClearFilter] = useState(true)
    const clearFilter = () => {
        setRegNumber([])
        setVinNumber([])
        getTableData()
        setClearFilter(!clearFilters)
    }

    useImperativeHandle(ref, () => ({
        downloadData: () => {
            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const excelFileName = "Service Summary Report";

            const checkServiceStatus = (DisToService) => {
                let label = "Not Due"
                if (DisToService >= 1000) {
                    label = "Not Due"
                }
                if (DisToService < 1000) {
                    label = "Due"
                }
                if (DisToService <= 0) {
                    label = "Over Due"
                }
                return label
            }

            const flatData = tableData?.map((item, index) => ({
                'Sr. no': index + 1,
                'VIN': item?.vehicleId,
                'Odometer': item?.odometer,
                "Service Due Status": checkServiceStatus(item?.distance_to_service),
                "DTS (Km)": item?.distance_to_service,
                "TTS (Days)": item?.time_to_service,
                "Last Service Date": item?.sr_last_service_date,
                "Uptime": item?.uptime_percent,


            }));

            const ws = XLSX.utils.json_to_sheet(flatData);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, excelFileName + fileExtension);
        }
    }))

    return (
        <div>
            <div className={`p-2 mb-3 border-1 rounded-2 p-4`} id="filterSearch" style={{ display: 'none', zIndex: 1, backgroundColor: "#f2f3fc" }}>
                <div className={`col-lg-12`}>
                    <div className='d-flex'>
                        <div className="">
                            <select className={`form-select ${styles.filter_dropdown}`} value={selectedField} onChange={(e) => setSelectedField(e.target.value)}>
                                <option value="VIN_NUM">VIN No.</option>
                                <option value="REG_NUM">Reg. No.</option>
                            </select>
                        </div>
                        <div className="col-md-3">
                            {
                                selectedField == "VIN_NUM" ?
                                    <CustomSelectButton apiEnd="service_summary_all_vin" clearFilters={clearFilters} filterdata={filterdata} updateFilter={updateFilter} />
                                    :
                                    <CustomSelectButton apiEnd="service_summary_all_reg" clearFilters={clearFilters} filterdata={filterdata} updateFilter={updateFilterForREGNo} />
                            }
                        </div>
                        <div className='d-flex  ms-auto'>
                            <button className={`btn btn-sm ms_btn me-2 active`} onClick={() => getTableData(vinNo, regNo)} >
                                Apply
                            </button>
                            <button className={`btn btn-sm ms_btn me-2`} onClick={() => clearFilter()}>
                                Clear filter
                            </button>

                        </div>
                    </div>

                </div>
                {/* <div className={`col-lg-1 col-md-6 col-sm-12  ${styles.bus_filtr_btn_bdt} ${styles.filter_bus_icon_bdt} ${filterdata?.pageSelected === 1 ? "" : "d-none"}`}> */}

                {/* </div> */}
            </div>

            <div className={`table-responsive ${styles.service_summary}`} style={{ overflowY: "scroll", height: "300px", position: "relative" }}>
                <table className="table table-hover table-bordered mb-0">
                    <thead>
                        <tr className={styles.service_summary_tablerow} style={{ backgroundColor: '#83a4cf', color: '#fff', position: 'sticky', top: -1, zIndex: 1 }}>
                            <th className="fw-bold">Vehicle Detail</th>
                            <th className="fw-bold">Service Due Status</th>
                            <th className="fw-bold">Distance to Service (km)</th>
                            <th className="fw-bold">Time to Service (Days)</th>
                            <th className="fw-bold">Last Service Date</th>
                            <th className="fw-bold">Uptime %</th>
                            <th className="fw-bold">Service Details</th>
                            {/* <th className="fw-bold">Service Adherence</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isLoading ? <ChartLoader />
                                : tableData?.length ?
                                    tableData.map((vehicle, index) => (
                                        <tr key={index} className={styles.service_summary_tablerowstyle}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className={`rounded-circle text-white d-flex align-items-center justify-content-center me-2 ${styles.service_summary_vehicle_icon}`}>
                                                        <i className="fas fa-truck"></i>
                                                    </div>
                                                    <div className='d-flex flex-column align-items-start'>
                                                        <p className="m-0 fw-bold">{vehicle.vehicleId}</p>

                                                        <div className=''>
                                                            <span className="m-0 medium">{vehicle.vehicle_registration_number}</span>
                                                            <span className="m-0 mx-1 small">|</span>
                                                            {vehicle.pl && <span className="m-0 small text-muted">{vehicle.pl}</span>}
                                                            <span className="m-0 mx-1 small">|</span>
                                                            {vehicle.lob && <span className="m-0 small text-muted">{vehicle.lob}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{serviceDueStatus(vehicle.distance_to_service)}</td>
                                            <td>{vehicle.distance_to_service}</td>
                                            <td>{vehicle.time_to_service}</td>
                                            <td>{vehicle.sr_last_service_date}</td>
                                            <td>{vehicle.uptime_percent ? Math.round(vehicle?.uptime_percent) + "%" : ""}</td>
                                            {/* <td>{vehicle.serviceDetails}</td> */}
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <button
                                                        className="btn ms_btn btn-link py-1 border-0 "
                                                        style={{ color: '#83a4cf', textDecoration: 'none' }}
                                                        data-toggle="modal" data-target={"#adherencePopover"}
                                                        onClick={() => handleServiceAdherenceClick(vehicle.vehicleId)}
                                                    >
                                                        <i className="fas fa-eye" ></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    : <tr> <td colSpan={8} className='text-center table-cell' > No Data found</td></tr>
                        }
                    </tbody>
                </table>

                <div>
                    <div id="adherencePopover" className="modal fade" role="dialog">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title text-capitalize">{"Service Details"}</h4>
                                    <button type="button" className="close" data-dismiss="modal">
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body p-0" style={{ overflowY: "scroll", height: "350px", }}>
                                    {isLoading ? <ChartLoader /> :
                                        Object.keys(modalData)?.length ?
                                            <div className="modal-body p-4">
                                                <div className="row g-4">
                                                    {/* VIN No. */}
                                                    <div className="col-md-6 d-flex">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }} >
                                                            <IoPersonOutline />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">

                                                            <div className="text-muted medium">Vin. No. -</div>
                                                            <div className="fw-bold">{modalData.vehicleId}</div>
                                                        </div>
                                                    </div>

                                                    {/* Reg No. */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaBook />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="text-muted medium">Reg. No. -</div>
                                                            <div className="fw-bold">{modalData.vehicle_registration_number}</div>
                                                        </div>
                                                    </div>

                                                    {/* Dealer Name */}
                                                    <div className="col-md-6 d-flex">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <IoPersonOutline />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="text-muted medium">Dealer Name -</div>
                                                            <div className="fw-bold">{modalData.dealer_name}</div>
                                                        </div>
                                                    </div>

                                                    {/* Job Card No */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaBook />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="text-muted medium">Job Card No -</div>
                                                            <div className="fw-bold">{modalData.ord_num}</div>
                                                        </div>
                                                    </div>

                                                    {/* Service Type */}
                                                    <div className="col-md-6 d-flex">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <IoPersonOutline />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="text-muted medium">Service Type -</div>
                                                            <div className="fw-bold">{modalData.sr_service_type}</div>
                                                        </div>
                                                    </div>

                                                    {/* Service Request No */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRegCreditCard />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className="text-muted medium">Service Request No -</div>
                                                            <div className="fw-bold">{modalData.sr_num}</div>
                                                        </div>
                                                    </div>

                                                    {/* JC Open Date */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRegCalendarAlt />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-center'>
                                                                <div className="text-muted medium">JC Open Date -</div>
                                                                <div className="fw-bold ms-1">{modalData.sr_opened_date}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* JC Close Date */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRegCalendarAlt />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-center'>
                                                                <div className="text-muted medium">JC Close Date -</div>
                                                                <div className="fw-bold ms-1">{modalData.sr_closed_date}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Invoice Date */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRegCalendarAlt />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-center'>
                                                                <div className="text-muted medium">Invoice Date -</div>
                                                                <div className="fw-bold ms-1">{modalData.invoice_dt}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Odometer */}
                                                    <div className="col-md-6 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <BsSpeedometer2 />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-center'>
                                                                <div className="text-muted medium">Odometer -</div>
                                                                <div className="fw-bold ms-1">{modalData.odometer}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Billed to customer */}
                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRegAddressCard />
                                                        </div>

                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-center'>
                                                                <div className="text-muted medium">Billed to the customer -</div>
                                                                <div className="fw-bold ms-1">{modalData.accnt_name}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Invoice Amount */}
                                                    <div className="col-md-12 d-flex align-items-center">
                                                        <div className={`rounded-circle bg-light d-flex align-items-center justify-content-center me-3 ${styles.service_modal_icon}`} style={{ width: '40px', height: '40px' }}>
                                                            <FaRupeeSign />
                                                        </div>
                                                        <div className="d-flex flex-column align-items-start">
                                                            <div className='d-flex align-items-start'>
                                                                <div className="text-muted medium">Invoice Amount -</div>
                                                                <div className="fw-bold ms-1">{modalData.invoice_amount}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : <div colSpan={6} className='text-center table-cell' > No Data found</div>
                                    }
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                                        CLOSE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default ServiceSummaryTable
